import React, { useCallback, useRef, useState } from 'react';
interface BeforeAfterProps {
  before: string;
  after: string;
  alt: string;
  beforeLabel: string;
  afterLabel: string;
  sliderLabel: string;
  hint: string;
}
export function BeforeAfter({
  before,
  after,
  alt,
  beforeLabel,
  afterLabel,
  sliderLabel,
  hint
}: BeforeAfterProps) {
  const [position, setPosition] = useState(50);
  const containerRef = useRef<HTMLDivElement>(null);
  const dragging = useRef(false);
  const updateFromClientX = useCallback((clientX: number) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = (clientX - rect.left) / rect.width * 100;
    setPosition(Math.min(100, Math.max(0, pct)));
  }, []);
  const onPointerDown = (event: React.PointerEvent) => {
    dragging.current = true;
    event.currentTarget.setPointerCapture(event.pointerId);
    updateFromClientX(event.clientX);
  };
  const onPointerMove = (event: React.PointerEvent) => {
    if (!dragging.current) return;
    updateFromClientX(event.clientX);
  };
  const onPointerUp = (event: React.PointerEvent) => {
    dragging.current = false;
    event.currentTarget.releasePointerCapture(event.pointerId);
  };
  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setPosition(p => Math.max(0, p - 5));
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      setPosition(p => Math.min(100, p + 5));
    }
  };
  return <div ref={containerRef} className="relative aspect-[4/5] w-full touch-none select-none overflow-hidden rounded-lg bg-navy" onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerUp} data-id="element-41" data-mp="9g0xsrgerxhw">
      <img src={after} alt={alt} className="absolute inset-0 h-full w-full object-cover" data-id="element-42" data-mp="3rs72jonimumb" />
      <div className="absolute inset-0 overflow-hidden" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} data-id="element-43" data-mp="3mue096pc2krb">
        <img src={before} alt="" aria-hidden="true" className="h-full w-full object-cover" data-id="element-44" data-mp="1qq7vth1nd7wx" />
      </div>

      <span className="pointer-events-none absolute left-3 top-3 rounded bg-navy/85 px-2 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-45" data-mp="1vnzo4c67ew1n">
        {beforeLabel}
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded bg-brand-orange px-2 py-1 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-46" data-mp="24hmgdsb7dh63">
        {afterLabel}
      </span>
      <span className="pointer-events-none absolute bottom-3 left-1/2 -translate-x-1/2 rounded bg-black/45 px-2 py-1 text-[11px] font-medium text-white" data-id="element-47" data-mp="1crrgj1ppy936">
        {hint}
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white" style={{
      left: `${position}%`
    }} data-id="element-48" data-mp="1lrwk10rsknc2">
        <button type="button" role="slider" tabIndex={0} aria-label={sliderLabel} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(position)} onKeyDown={onKeyDown} className="pointer-events-auto absolute top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-navy text-white shadow-lift" data-id="element-49" data-mp="2s7gtmazfp7qv">
          <span className="text-xs font-bold" aria-hidden="true" data-id="element-50" data-mp="2tiag1kw6hxon">
            ‹›
          </span>
        </button>
      </div>
    </div>;
}